import React from "react";
import { Box, CircularProgress } from "@mui/material";
import FileUploader from "./FileUploader";
import DataPreviewTable from "./DataPreviewTable";

interface StepUploadProps {
  file: File | null;
  onFileSelect: (file: File) => void;
  data: any[]; // Replace 'any' with a specific type if known
  columns: string[]; // Replace 'string' with a specific type if known
  loading: boolean;
}

export const StepUpload: React.FC<StepUploadProps> = ({ file, onFileSelect, data, columns, loading }) => (
  <Box>
    <FileUploader onFileSelect={onFileSelect} selectedFile={file} />
    
    {loading && (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    )}

    {!loading && columns.length > 0 && (
      <DataPreviewTable data={data} columns={columns} />
    )}
  </Box>
);


export default StepUpload;